import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import history from "../utils/history";
import apiPlatformResponseViolationsParser from "../utils/apiPlatformResponseViolationsParser";
import Button from "../components/Button";
import {Alert, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {Translation} from "react-i18next";

const unloadCallback = (event) => {
  event.preventDefault();
  event.returnValue = "";
  return "";
};

class AppForm extends Component {
  static contextTypes = {
    router: () => true,
  }

  constructor(props) {
    super(props);

    this.formRef = React.createRef();

    this.state = {
      historyDirection: null,
      exitProtectionConfirmed: false,
      exitProtectionPath: null,
      exitProtectionModal: false,
      saving: false,
      errors: {},
    }
  }

  componentDidMount() {
    window.addEventListener("beforeunload", unloadCallback);

    this.historyUnblock = history.block((e, historyDirection) => {
      if(!this.state.exitProtectionConfirmed){
        this.setState({
          historyDirection,
          exitProtectionPath: e.pathname,
          exitProtectionModal: true,
        })
      }

      return this.state.exitProtectionConfirmed
    })
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", unloadCallback);
    this.historyUnblock()
  }

  handleOnConfirmExit = () => {
    this.setState({
      exitProtectionConfirmed: true,
    }, () => {
      if(this.state.historyDirection === 'POP'){
        history.goBack()
      }else{
        history.push(this.state.exitProtectionPath)
      }
    })
  }

  onSubmit = (data) => {
    this.setState({saving: true});
    this.props.onSavingChange && this.props.onSavingChange(true);

    this.setState({
      errors: {},
    });

    if (this.props.apiFn?.custom) {
      return this.props.apiFn.custom(data)
        .then(res => {
          this.setState({
            saving: false,
            exitProtectionConfirmed: true,
          });
          this.props.onSavingChange && this.props.onSavingChange(false);

          if (this.props.onSaved) {
            this.props.onSaved(res.data);
          }
          if (this.props.onCustomAction) {
            this.props.onCustomAction(res.data);
          }
        })
        .catch(res => {
          this.setState({
            saving: false,
          });
          this.props.onSavingChange && this.props.onSavingChange(false);

          this.setState({
            errors: apiPlatformResponseViolationsParser(res?.response?.data?.violations),
          });
        });
    } else {
      if (!this.props?.data?.id) {
        return this.props.apiFn.create({
          ...data,
          ...this.props.dataAdditional,
        })
          .then(res => {
            this.setState({
              saving: false,
              exitProtectionConfirmed: true,
            });
            this.props.onSavingChange && this.props.onSavingChange(false);
            if (this.props.onSaved) {
              this.props.onSaved(res.data);
            }
            if (this.props.onCreated) {
              this.props.onCreated(res.data);
            }
          })
          .catch(res => {
            this.setState({
              saving: false,
            });
            this.props.onSavingChange && this.props.onSavingChange(false);

            this.setState({
              errors: apiPlatformResponseViolationsParser(res?.response?.data?.violations),
            });
          });
      } else {
        return this.props.apiFn.update({
          ...data,
          ...this.props.dataAdditional,
        })
          .then(res => {
            this.setState({
              saving: false,
              exitProtectionConfirmed: true,
            });
            this.props.onSavingChange && this.props.onSavingChange(false);
            if (this.props.onSaved) {
              this.props.onSaved(res.data);
            }
            if (this.props.onUpdated) {
              this.props.onUpdated(res.data);
            }
          })
          .catch(res => {
            this.setState({
              saving: false,
            });
            this.props.onSavingChange && this.props.onSavingChange(false);

            this.setState({
              errors: apiPlatformResponseViolationsParser(res?.response?.data?.violations),
            });
          });
      }
    }
  }

  submit = () => {
    return this.formRef.current.submit()
  };

  render() {
    return (
      <div className="d-flex flex-column">
        {this.state.exitProtectionModal && <Modal isOpen color={'warning'} scrollable>
          <ModalHeader><Translation>{t => t('app_form:exit_protection_modal.title')}</Translation></ModalHeader>
          <ModalBody>
            <Alert color={'warning'}>
              <div className="d-flex flex-row flex-nowrap align-items-center">
                <i className="fas fa-info-circle fa-2x mr-2" />
                <span><Translation>{t => t('app_form:exit_protection_modal.alert_text')}</Translation></span>
              </div>
            </Alert>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.handleOnConfirmExit}><Translation>{t => t('app_form:exit_protection_modal.btn_exit')}</Translation></Button>
            <Button onClick={() => this.setState({
              exitProtectionModal: false,
            })}><Translation>{t => t('app_form:exit_protection_modal.btn_stay')}</Translation></Button>
          </ModalFooter>
        </Modal>}

        {React.createElement(this.props.form, {
          ref: this.formRef,
          onSubmit: this.onSubmit,
          data: this.props.data || undefined,
          errors: this.state.errors,
        })}

        {this.props.saveButton && <div className="d-flex justify-content-end">
          <Button
            color="light"
            onClick={history.goBack}
          ><Translation>{t => t('common:btn.cancel')}</Translation></Button>
          <Button
            className="ml-3"
            loading={this.state.saving}
            onClick={() => {
              this.formRef.current.submit();
            }}
          >
            <i className="fas fa-save" />
            <span><Translation>{t => t('common:btn.save')}</Translation></span>
          </Button>
        </div>}
      </div>
    );
  }
}

AppForm.defaultProps = {
  saveButton: true,
};

AppForm.propTypes = {
  saveButton: PropTypes.bool,
  data: PropTypes.object,
  form: PropTypes.any.isRequired,
  apiFn: PropTypes.shape({
    create: PropTypes.func,
    update: PropTypes.func,
    custom: PropTypes.func
  }).isRequired,
  onSavingChange: PropTypes.func,
  onCreated: PropTypes.func,
  onUpdated: PropTypes.func,
  onSaved: PropTypes.func,
  onCustomAction: PropTypes.func
};

export default connect(null, null, null, {forwardRef: true})(AppForm);
